import { Box, Link, Text } from '@ksyos/design-system';

export function HelpFooter() {
    return (
        <Box
            mb={8}
            mt={8}
        >
            <Text
                color="minimal"
                mb={1}
                size="sm"
                textAlign="center"
            >
                Hulp nodig?
            </Text>
            <Text
                color="minimal"
                size="sm"
                textAlign="center"
            >
                Bel{' '}
                <Text
                    as="span"
                    color="minimal"
                    fontWeight="bold"
                    size="sm"
                >
                    020-236 65 33{' '}
                </Text>
                (ma-vr 8:30 - 17:00) of mail{' '}
                <Link
                    color="minimal"
                    href="mailto:polikliniek@ksyos.nl"
                    variant="externalLink"
                >
                    polikliniek@ksyos.nl
                </Link>
                <br />
            </Text>
        </Box>
    );
}
